module.exports = __webpack_public_path__ + "image/qr_video_f9086.png";